import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { ConcepItem } from "./ConcepItem";


interface Props {
    listParameters: any;
    functionModalEvent: Function;
    value: number;
    onChange?: Function;
    CuotaValue?: any;
    filterParameters?: [];
    PaidValues?: any;
}

export const ComponentDistributionValues = forwardRef(({ functionModalEvent, value, listParameters, onChange, CuotaValue, PaidValues }: Props, ref) => {
    const modalDistribucion = useModal("Distribución", MODAL_md);
    const [diferencia, setDiferencia] = useState<number>(0);
    const [concept, setConcept] = useState<any>([]);
    const [type, setType] = useState<number>();
    const [obs, setObs] = useState<string>("");

    const toNumber = (x: any) => {
        const n = Number(x);
        return Number.isFinite(n) ? n : 0;
    };

    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized && !type) {
            if (CuotaValue && value === CuotaValue.ValorCuota) {
                setType(3);
            } else {
                setType(1);
            }
            setInitialized(true);
        }
    }, [CuotaValue, value, type, initialized]);


    useEffect(() => {
        if (listParameters?.length > 0) {
            setConcept(listParameters);

            if ((type === 1 || type === 2 || type === 3 || type === 4) && CuotaValue) {
                allocateByPriority(type as 1 | 2 | 3 | 4, listParameters);
            }
        }
    }, [listParameters, type, CuotaValue]);

    useEffect(() => {
        if (!type) {
            resetConceptToZero();
            return;
        }

        resetConceptToZero();
        setTimeout(() => {
            allocateByPriority(type as 1 | 2 | 3 | 4);
        }, 10);
    }, [type]);


    const totalValue = concept.reduce((acc, item) => {
        const v = item.DataBeanProperties.Value || 0;
        return acc + v;
    }, 0);

    const typeSigns: Record<number, 1 | -1> = {
        2: 1,  // Capital Corriente
        3: 1,  // Capital Mora
        4: 1,  // Interés corriente
        6: 1,  // Interés mora
        8: 1,  // Transitoria CXC
    };

    const updateMovement = () => {
        const nextConcept = [...concept];

        const menorValor: any[] = nextConcept.filter((item) => item.DataBeanProperties.Type === 3);
        const capital: any[] = nextConcept.filter((item) => item.DataBeanProperties.Type === 2);

        const menorVal = menorValor.length > 0 ? menorValor[0].DataBeanProperties.Value ?? 0 : 0;
        const capitalVal = capital.length > 0 ? capital[0].DataBeanProperties.Value ?? 0 : 0;

        nextConcept.forEach((element) => {
            if (element.DataBeanProperties.Type === 2 || element.DataBeanProperties.Type === 3) {
                element.DataBeanProperties.Value = toNumber(element.DataBeanProperties.Value);
            }
        });

        const move = nextConcept
            .filter((el) => toNumber(el.DataBeanProperties.Value))
            .map((el) => {
                const sign = typeSigns[el.DataBeanProperties.Type] ?? 1;
                return {
                    Value: toNumber(el.DataBeanProperties.Value) * sign,
                    Type: el.DataBeanProperties.Type,
                };
            });


        const sumaM = move.reduce(
            (acc: number, item: any) => acc + parseFloat(item.Value),
            0
        );

        let obj = {
            IDLoanQuota: CuotaValue.IDCreditHistory,
            Value: sumaM,
            IDLoanLine: CuotaValue.IDLoanLine,
            LoanNumber: CuotaValue.CreditNumber,
            Movements: move,
            Description: obs,
        };
        console.log(obj);

        if (functionModalEvent) functionModalEvent(obj);
    };

    const updateConcept = (e) => {
        const targetType = e.Type;
        const proposedValue = toNumber(e.Value);
        const totalPermitido = toNumber(value);

        const baseTotal = concept.reduce((acc, el) => {
            let v = toNumber(el.DataBeanProperties.Value);
            if (el.DataBeanProperties.Type === 3) v = v * -1;
            return el.DataBeanProperties.Type == targetType ? acc : acc + v;
        }, 0);

        const appliedValue = proposedValue;
        const nextTotal = baseTotal + appliedValue;
        const nextDiff = totalPermitido - nextTotal;

        const nextConcept = [...concept].map((el) => {
            if (el.DataBeanProperties.Type == targetType) {
                return {
                    ...el,
                    DataBeanProperties: {
                        ...el.DataBeanProperties,
                        Value: appliedValue,
                    },
                };
            }
            return el;
        });

        setConcept(nextConcept);
        setDiferencia(nextDiff);
        setObs("");
    };

    const openModal = () => {
        modalDistribucion.open();
    };

    const closeModal = () => {
        modalDistribucion.close();
    };

    useImperativeHandle(ref, () => ({
        openModal,
        closeModal,
    }));

    const allocateByPriority = (priority: 1 | 2 | 3 | 4, baseConcept?: any[]) => {
        const source = Array.isArray(baseConcept) ? baseConcept : concept;
        if (!CuotaValue || !Array.isArray(source) || source.length === 0) return;


        console.log("Update Priority => ", priority);

        // if (priority === 4 && PaidValues?.Movements) {
        if (PaidValues?.Movements) {
            const movimientos = PaidValues.Movements;
            const nextConcept = source.map((el) => {
                const movimiento = movimientos.find(
                    (mov: any) => mov.Type === el.DataBeanProperties.Type
                );
                return {
                    ...el,
                    DataBeanProperties: {
                        ...el.DataBeanProperties,
                        Value: movimiento ? toNumber(movimiento.Value) : 0,
                    },
                };
            });

            setConcept(nextConcept);
            setDiferencia(0);

            onChange?.(
                nextConcept
                    .filter((el) => toNumber(el.DataBeanProperties.Value) > 0)
                    .map((el) => ({
                        Value: toNumber(el.DataBeanProperties.Value),
                        Type: el.DataBeanProperties.Type,
                    }))
            );
            return;
        }

        const totalPermitido = toNumber(value);
        const interesDue = toNumber(CuotaValue.InteresCorriente);
        const capitalDue = toNumber(CuotaValue.CapitalCorriente);
        const capitalMoraDue = toNumber(CuotaValue.CapitalMora);
        const interesMoraDue = toNumber(CuotaValue.InteresMora);
        const cuentaCobro = toNumber(value);

        const othersTotal = source.reduce((acc, el) => {
            const t = el.DataBeanProperties.Type;
            const v = toNumber(el.DataBeanProperties.Value);
            return (t === 2 || t === 3 || t === 4 || t === 6 || t === 8) ? acc : acc + v;
            // return acc + v;
        }, 0);

        let remaining = totalPermitido - othersTotal;

        let order: { type: number; due: number }[] = [];

        if (priority === 1) {

            order = [
                { type: 8, due: cuentaCobro },
                { type: 6, due: interesMoraDue },
                { type: 4, due: interesDue },
                { type: 3, due: capitalMoraDue },
                { type: 2, due: capitalDue },
            ];
        } else if (priority === 2) {
            order = [
                { type: 8, due: cuentaCobro },
                { type: 3, due: capitalMoraDue },
                { type: 2, due: capitalDue },
                { type: 6, due: interesMoraDue },
                { type: 4, due: interesDue },
            ];
        } else if (priority === 3) {
            order = [
                { type: 8, due: cuentaCobro },
                { type: 6, due: interesMoraDue },
                { type: 4, due: interesDue },
                { type: 3, due: capitalMoraDue },
                { type: 2, due: capitalDue },
            ];
        }
        else if (priority === 4) {
            order = [
                { type: 8, due: cuentaCobro },
                { type: 6, due: interesMoraDue },
                { type: 4, due: interesDue },
                { type: 3, due: capitalMoraDue },
                { type: 2, due: capitalDue },
            ];
        }

        const assigned: Record<number, number> = {};
        order.forEach(({ type, due }) => {
            const assign = priority === 3 ? due : Math.min(remaining, due);
            assigned[type] = assign;
            remaining -= assign;
        });

        const nextConcept = source.map((el) => {
            const t = el.DataBeanProperties.Type;
            if (assigned[t] !== undefined) {
                return {
                    ...el,
                    DataBeanProperties: {
                        ...el.DataBeanProperties,
                        Value: toNumber(assigned[t]),
                    },
                };
            }
            return el;
        });

        const distributed = Object.values(assigned).reduce((a, b) => a + b, othersTotal);
        const nextDiff = Math.max(0, totalPermitido - distributed);

        setConcept(nextConcept);
        setDiferencia(nextDiff);

        onChange?.(
            nextConcept
                .filter((el) => toNumber(el.DataBeanProperties.Value) > 0)
                .map((el) => ({
                    Value: toNumber(el.DataBeanProperties.Value),
                    Type: el.DataBeanProperties.Type,
                }))
        );
    };



    const resetConceptToZero = () => {
        const nextConcept = concept.map((el: any) => ({
            ...el,
            DataBeanProperties: { ...el.DataBeanProperties, Value: 0 },
        }));
        setConcept(nextConcept);
        setDiferencia(Number(value) || 0);
        onChange?.([]);
    };

    return (
        <Modal
            modal={modalDistribucion.modal}
            updateModal={modalDistribucion.setModal}
            eventModal={updateMovement}
            onSubmitLabel="Aplicar Pago"
        >
            <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>Valor Descuento/Pago </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(value, 2) }} />
                </div>
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>Valor Cuota </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(CuotaValue.ValorCuota, 2) }} />
                </div>
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>Aplicacion Pago </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(totalValue, 2) }} />
                </div>
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>Diferencia Cuota </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(CuotaValue.ValorCuota - totalValue, 2) }} />
                </div>
                <div className="col-md-12 d-flex justify-content-start">
                    <strong style={{ marginRight: "6px" }}>
                        {value - totalValue > 0 ? "Valor Mayor Pagado" : "Menor Valor en Cuota"}
                    </strong>
                    <small dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(value - totalValue, 2) }} />
                </div>

                {CuotaValue && (
                    <div className="col-md-12">
                        <label>Tipo de Asignación</label>
                        <select
                            className="form-select"
                            value={type}
                            onChange={(e) => {
                                const val = e.target.value ? Number(e.target.value) : null;
                                setType(val);
                            }}
                        >
                            <option value="">...</option>
                            <option value="1">Primero Interes</option>
                            <option value="2">Primero Capital</option>
                            <option disabled={CuotaValue?.ValorCuota != value} value="3">
                                Valor Exacto
                            </option>
                            <option disabled={!PaidValues?.Movements?.length} value="4">
                                Cuenta por Cobrar
                            </option>
                        </select>
                    </div>
                )}
                <div className="col-md-12">
                    <div className="row">
                        {concept.map((row: any, index: number) => (
                            <ConcepItem key={index} item={row.DataBeanProperties} onChange={updateConcept} />
                        ))}
                    </div>
                </div>
                <div className="col-md-12">
                    {/* <PrintJson json={PaidValues}/> */}
                    {/* <PrintJson json={listParameters}/> */}
                </div>

            </div>
        </Modal>
    );
}
);
